import { useTranslation } from 'react-i18next';
import TaniumIcon from '../../../assets/images/tanium-icon.svg';
import { IntegrationAccordion } from '../../../common/components/IntegrationAccordion';
import { Tanium } from '../../../integrations/tanium/models/Tanium';
import { TaniumAccordionForm } from './TaniumAccordionForm';
import { CheckTaniumIntegrationArgs, UpdateTaniumIntegrationArgs } from '../../../integrations/tanium/services/TaniumRepository';
import { useState } from 'react';

type Props = {
  tanium: Tanium | null;
  isLoading: boolean;
  canUpdate: boolean;
  onTestClick: (args: CheckTaniumIntegrationArgs) => void;
  onConnectClick: (args: UpdateTaniumIntegrationArgs) => void;
  onUnlinkClick: () => void;
};

export const TaniumAccordion = (props: Props) => {
  const { tanium, isLoading, onConnectClick, onTestClick, canUpdate, onUnlinkClick } = props;
  const { t } = useTranslation();
  const isTaniumEnabled = tanium !== null;
  const [isExpanded, setIsExpanded] = useState(true);
  const handleAccordionClick = () => {
    setIsExpanded((prev) => !prev);
  };

  return (
    <IntegrationAccordion
      isExpanded={isExpanded}
      onClick={handleAccordionClick}
      isLoading={isLoading}
      isConfigured={isTaniumEnabled}
      title={t('integrationList.tanium.title')}
      subtitle={t('integrationList.tanium.description')}
      icon={<TaniumIcon width="32" height="32" />}
      details={
        !isLoading && (
          <TaniumAccordionForm canUpdate={canUpdate} tanium={tanium} onUnlinkClick={onUnlinkClick} onConnectClick={onConnectClick} onTestClick={onTestClick} />
        )
      }
    />
  );
};
